import { CreateDonationRequestModeEnum } from '@/app/api';
import { PaymentMethod } from '@/app/enums';
import { countryConfig } from '@/app/utils/countryConfig';
import { useMemo } from 'react';

export enum PaymentMethodFormType {
  Single = 'single',
  LongTerm = 'long-term',
  Commercial = 'commercial',
  GoodHabit = 'good-habit',
}

export const usePaymentMethods = (
  formType: PaymentMethodFormType,
  donationMode?: CreateDonationRequestModeEnum | null,
) => {
  return useMemo(() => {
    if (donationMode === CreateDonationRequestModeEnum.LongTerm) {
      return [PaymentMethod.WireTransfer, PaymentMethod.Card].filter((option) =>
        countryConfig.charityCollections.longTerm.includes(option),
      );
    }

    const baseOptions = [PaymentMethod.WireTransfer, PaymentMethod.Card, PaymentMethod.QrCode];

    switch (formType) {
      case PaymentMethodFormType.LongTerm:
        return countryConfig.charityCollections.longTerm;

      case PaymentMethodFormType.Commercial:
        return countryConfig.commercialProjects.availablePaymentMethods;

      case PaymentMethodFormType.GoodHabit:
        return countryConfig.goodHabit.enabled ? countryConfig.goodHabit.availablePaymentMethods : baseOptions;

      case PaymentMethodFormType.Single:
      default:
        return countryConfig.charityCollections.single;
    }
  }, [formType, donationMode]);
};
